type AnimateWorkspaceAgentOnboardingParkScrollParams = {
  durationMs: number;
  element: HTMLElement;
  onComplete: () => void;
  targetScrollTop: number;
};

const easeOutCubic = (progress: number): number => {
  const remaining = 1 - progress;

  return 1 - remaining * remaining * remaining;
};

/** rAF scroll for hybrid-turn park — duration is under our control unlike `scrollTo({ behavior: 'smooth' })`. */
export const animateWorkspaceAgentOnboardingParkScroll = ({
  durationMs,
  element,
  onComplete,
  targetScrollTop,
}: AnimateWorkspaceAgentOnboardingParkScrollParams): (() => void) => {
  const startScrollTop = element.scrollTop;
  const delta = targetScrollTop - startScrollTop;
  let cancelled = false;

  const finish = () => {
    if (cancelled) {
      return;
    }

    onComplete();
  };

  if (Math.abs(delta) <= 1 || durationMs <= 0) {
    element.scrollTop = targetScrollTop;
    finish();

    return () => {
      cancelled = true;
    };
  }

  const startTime = performance.now();
  let frameId = 0;

  const tick = (now: number) => {
    if (cancelled) {
      return;
    }

    const elapsed = now - startTime;
    const progress = Math.min(1, elapsed / durationMs);

    element.scrollTop = startScrollTop + delta * easeOutCubic(progress);

    if (progress < 1) {
      frameId = requestAnimationFrame(tick);
      return;
    }

    finish();
  };

  frameId = requestAnimationFrame(tick);

  return () => {
    cancelled = true;
    cancelAnimationFrame(frameId);
  };
};
